<template>
    <div>
        <div class="row statement">
            <div>
                <div id="statement-header">
                    <div class="public-statement-header-back-btn">
                        <h1>{{`${election.title1}`}}</h1>
                        <div>
                            <div class="base btn-blue caps">
                                <button class="btn-mr" @click="onBackClickedHandler()">Back</button>
                            </div>
                        </div>
                    </div>
                    <h2>{{`${contest.title}`}}</h2>
                    <h2 class="mtb-0">{{candidateStatementInfo.candidateName}} &mdash; {{Occupation}}</h2>
                </div>
                <hr/>
                <div id="reset" :dir="textDirection" v-html="ReadPublicEnglishStatement"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { ASSETS } from '@/assets/js/assets.js'
    export default {
        computed: {
            ...mapGetters(["candidateStatementInfo", "contest", "election"]),
            ReadPublicEnglishStatement() {
                const lang = this.candidateStatementInfo.selectedLanguage;
                const statement = this.candidateStatementInfo.candidateStatements.find(s => s.language === lang);
                this.CheckLanguage(lang)
                return statement ? statement.statement : this.$t("LabelNoStatement");
            },
            Occupation() {
                return this.candidateStatementInfo.selectedCandidate.occupation;
            }
        },
        data: () => ({
            textDirection: ''
        }),
        methods: {
            CheckLanguage(selectedLanguage) {
                if (selectedLanguage === ASSETS.LanguageSelection.locale.Farsi) {
                    this.textDirection = 'rtl'
                } else {
                    this.textDirection = 'ltr'
                }
            },
            onBackClickedHandler() {
                this.$router.push("/candidate-statements")
            },
        },
        mounted() {
            scrollTo(0,0);
        }
    }
</script>
